module.exports = __webpack_public_path__ + "src/assets/img/Amphisbaena_camura_small.f563bade.jpg";